import { useQuery } from '@tanstack/react-query'

import chatService from '../services'

export const playerChatStatsQueryKey = (roomId: string) => [
	'chat',
	'player-stats',
	roomId,
]

/**
 * Hook to fetch player stats for chat room with polling support
 * @param roomId - Chat room ID
 * @param enabled - Whether to enable the query
 * @param refetchInterval - Polling interval in milliseconds (default: 10000ms = 10s)
 */
export function useQueryPlayerChatStats(
	roomId: string,
	enabled = true,
	refetchInterval = 10000,
) {
	return useQuery({
		queryKey: playerChatStatsQueryKey(roomId),
		queryFn: () => chatService.getPlayerChatStats(roomId),
		enabled: enabled && !!roomId,
		refetchInterval: enabled ? refetchInterval : false,
		staleTime: 5000, // Consider data stale after 5 seconds
	})
}
